<template>
  <div>
    <Reports :embed="true" />
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      
    };
  },
};
</script>